import { initProductSelection, initStepGating } from './shared.js';
import initSelect2 from '../helpers/select2.js';
import initAutosize from '../helpers/autosize.js';
import initDatepicker from '../helpers/datepicker.js';
import { addNewPrototype, getPrrcInfo, removePrototype } from '../helpers/helper.js';

const initSupplierComplaintForm = () => {
	if(!$('#supplier-complaint-add-edit-container').length){
		return;
	}

	const errorType = $('#error_type');
	const errorTypeOther = $('#error_type_other');
	const productSelectClass = '.supplier-complaint-product-select';
	const quantityAffected = $('#quantity_affected_items');

	const toggleGroup = (field, show) => {
		if(!field.length){
			return;
		}
		const group = field.closest('.form-group');
		if(show){
			group.removeClass('d-none');
		}else{
			group.addClass('d-none');
		}
	};

	const toggleErrorOther = () => {
		toggleGroup(errorTypeOther, errorType.val() === 'other');
	};

	const getProductMeta = (select) => {
		if(!select || !select.length){
			return {};
		}
		const raw = select.attr('data-product-meta') || select.data('product-meta');
		if(!raw){
			return {};
		}
		if(typeof raw === 'object'){
			return raw;
		}
		try{
			return JSON.parse(raw);
		}catch(error){
			return {};
		}
	};

	const syncSupplierFromProduct = (select) => {
		const productId = select.val();
		if(!productId){
			return;
		}
		const meta = getProductMeta(select);
		const supplierId = meta ? meta[productId] : null;
		if(!supplierId){
			return;
		}
		const supplierSelect = $('#supplier');
		if(!supplierSelect.length){
			return;
		}
		if(supplierSelect.val() != supplierId){
			supplierSelect.val(supplierId).trigger('change');
		}
	};

	const getQuantityInputs = () => {
		return $(`${productSelectClass}`).map((index, element) => {
			const row = $(element).closest('.main-row');
			return row.find('input[name$="[quantity]"]').get(0);
		}).get().filter(Boolean);
	};

	let syncingQuantity = false;
	const syncQuantityAffected = (force = false) => {
		if(!quantityAffected.length){
			return;
		}
		if(!force && quantityAffected.data('manual')){
			return;
		}

		let sum = 0;
		let hasValue = false;

		getQuantityInputs().forEach((input) => {
			const raw = $(input).val();
			if(raw === null || raw === undefined || raw === ''){
				return;
			}
			const normalized = raw.toString().replace(',', '.');
			const value = parseFloat(normalized);
			if(Number.isNaN(value)){
				return;
			}
			hasValue = true;
			sum += value;
		});

		syncingQuantity = true;
		if(hasValue && sum > 0){
			quantityAffected.val(sum);
		}else{
			quantityAffected.val('');
		}
		syncingQuantity = false;
	};

	const bindProductSelectEvents = () => {
		$(document).off('change.supplier-complaint-product select2:select.supplier-complaint-product select2:clear.supplier-complaint-product', productSelectClass);
		$(document).on('change.supplier-complaint-product select2:select.supplier-complaint-product select2:clear.supplier-complaint-product', productSelectClass, function () {
			const select = $(this);
			syncSupplierFromProduct(select);
			syncQuantityAffected();
		});
	};

	const bindQuantityEvents = () => {
		$(document).off('input.supplier-complaint-quantity change.supplier-complaint-quantity', 'input[name$="[quantity]"]');
		$(document).on('input.supplier-complaint-quantity change.supplier-complaint-quantity', 'input[name$="[quantity]"]', () => {
			syncQuantityAffected();
		});

		if(quantityAffected.length){
			quantityAffected.off('input.supplier-complaint-total change.supplier-complaint-total').on('input.supplier-complaint-total change.supplier-complaint-total', () => {
				if(!syncingQuantity){
					quantityAffected.data('manual', true);
				}
			});
		}
	};

	const initProductPrototype = () => {
		addNewPrototype('add-new-prototype-supplier-complaint-product', () => {
			initSelect2();
			bindProductSelectEvents();
			bindQuantityEvents();
			const newSelect = $(productSelectClass).last();
			if(newSelect.length){
				syncSupplierFromProduct(newSelect);
			}
			syncQuantityAffected();
		}, () => {
			syncQuantityAffected();
		});
	};

	const initActivityPrototype = () => {
		const activitySelector = '[data-function="add-new-prototype-activity"]';

		$(activitySelector).off('click.add-new-prototype');
		$(document).off('click.supplier-complaint-activity', activitySelector);
		$(document).on('click.supplier-complaint-activity', activitySelector, function () {
			const target = $(this).data('target');
			const type = $(this).data('type');
			const text = $(this).data('text');

			if(!target){
				return;
			}

			if(type !== 'other'){
				$(`[data-function="add-new-prototype-activity"][data-type="${type}"]`).next().remove();
				$(`[data-function="add-new-prototype-activity"][data-type="${type}"]`).remove();
			}

			const prototypeHolder = $(`[data-prototype-name="${target}"]`);
			if(!prototypeHolder.length){
				return;
			}

			$(`[data-prototype-container="${target}"]`).find('.no-records').remove();

			const prototypeHtml = prototypeHolder.data('prototype-html');
			if(!prototypeHtml){
				return;
			}

			const uuid = parseInt(Math.random() * Math.floor(9899) + 100);
			const prototype = prototypeHtml.replace(/__NAME__/g, uuid);
			prototypeHolder.before(prototype);

			const container = prototypeHolder.prev();
			container.find('[data-id="type"]').val(type);
			container.find('[data-id="info_text"]').html(text || '');

			initAutosize();
			initDatepicker();
			removePrototype();

			const input = container.find('input[type="text"], select, textarea').eq(0);
			input.focus();
		});
	};

	const initSupplierHandler = () => {
		const supplierSelect = $('[data-function="supplier-handler"]');
		if(!supplierSelect.length){
			return;
		}

		supplierSelect.unbind('change.supplier-complaint-supplier-handler').bind('change.supplier-complaint-supplier-handler', function(){
			$('[data-id="supplier_email"]').val('');
			$('[data-id="prrc_clinic_email"]').val('');
			$('[data-id="prrc_clinic_phone"]').val('');
			$('[data-id="supplier_ch_rep"]').val('');
			$('[data-id="supplier_ch_rep_number"]').val('');
			const linkedSupplierFields = $('[data-id="supplier_email"], [data-id="prrc_clinic_email"], [data-id="prrc_clinic_phone"], [data-id="supplier_ch_rep"], [data-id="supplier_ch_rep_number"]');
			linkedSupplierFields.prop('disabled', false);

			const value = $(this).val();
			if(value === null || value === undefined || !/^\d+$/.test(value.toString())){
				return;
			}

			getPrrcInfo(value, (data) => {
				if(data.id){
					$('[data-id="supplier_email"]').val(data.email_security);
					$('[data-id="prrc_clinic_email"]').val(data.important_contact_email);
					$('[data-id="prrc_clinic_phone"]').val(data.important_contact_phone);
					$('[data-id="supplier_ch_rep"]').val(data.ch_rep);
					$('[data-id="supplier_ch_rep_number"]').val(data.ch_rep_number);
				}
			});
		});
	};

	errorType.unbind('change.supplier-complaint-error').bind('change.supplier-complaint-error', toggleErrorOther);

	toggleErrorOther();
	initSupplierHandler();
	bindProductSelectEvents();
	bindQuantityEvents();
	$(productSelectClass).each((index, element) => {
		syncSupplierFromProduct($(element));
	});
	if(!quantityAffected.val()){
		syncQuantityAffected(true);
	}
	initProductPrototype();
	initActivityPrototype();

	initStepGating({
		containerSelector: '[data-supplier-complaint-step]',
		messageSelector: '.supplier-complaint-step-message',
		disabledClass: 'supplier-complaint-step-disabled',
		eventNamespace: 'supplier-complaint-step'
	});
	initProductSelection();
};

export default initSupplierComplaintForm;
